import { useEffect, useMemo, useState } from "react";
import Table from "../../components/GTable/Table";
import { GetCoponsData } from "../../lib/data";
import Button from "../../components/GButton/Button";
import { coponsColumns } from "../../lib/definitions";
import { deleteCoponsForm } from "../../lib/actions";
import DeleteRecord from "../../ui/Models/deleteRecord";
import Pagination from "../../ui/paginations/Paginations";
import TableSkeleton from "../../ui/sharedUi/tableSkeleton";
import { useSearchParams } from "react-router-dom";
import i18n from "../../lib/i18n";
import CoponsFilter from "../../ui/searchFilter/coponsFilter";

export default function Copons() {

    const [searchParams] = useSearchParams();
    const [coponsData, setCoponsData] = useState([]);
    const [currentPage, setcurrentPage] = useState(1);
    const [last_page, setlast_page] = useState(1);
    const [deleteConfirmation, setDeleteConfirmation] = useState({ isOpen: false, idToDelete: null });
    const [isLoading, setIsLoading] = useState(true);  
    const [loadingDelete, setLoadingDelete] = useState(false);  
    const name = searchParams.get('name');
    const from_date = searchParams.get('from_date');
    const to_date = searchParams.get('to_date');
    const t = i18n.t.bind(i18n); 

    const params = useMemo(() => {
        const tempParams = [];
        if (from_date) tempParams.push({ from_date });
        if (name) tempParams.push({ name });
        if (to_date) tempParams.push({ to_date });

        return tempParams;
    }, [ to_date, from_date, name]);

    useEffect(() => {
        handleApi();
    }, [currentPage, params]);

    const handleApi = async () => {
        setIsLoading(true); 
        const coponData = await GetCoponsData(currentPage, params);
        setCoponsData([]);
        coponData.data.map((e) => setCoponsData((prev) => [...prev, e]));
        setcurrentPage(coponData.pagination.current_page);
        setlast_page(coponData.pagination.last_page);
        setIsLoading(false);  
    };

    const handlePageChange = (page) => {
        setcurrentPage(page);
    };

    const openDeleteConfirmation = (id) => {
        setDeleteConfirmation({ isOpen: true, idToDelete: id });
    };

    const closeDeleteConfirmation = () => {
        setDeleteConfirmation({ isOpen: false, idToDelete: null });
    };

    const handelDelete = async () => {
        if (deleteConfirmation.idToDelete) {
            setLoadingDelete(true);
            const result = await deleteCoponsForm(deleteConfirmation.idToDelete);
            if (result) {
                setLoadingDelete(false);
                handleApi();
            }
            closeDeleteConfirmation();
        }
    };

    return (
        <div className="p-8 sm:p-6 md:p-8">
            <div className="">
                <CoponsFilter values={params} />
            </div>
            <div className="flex flex-col sm:flex-row sm:items-baseline border-t border-gray-500/100 bg-thirdly  justify-between px-5 py-5  gap-4">
                <div></div>
                <Button background="#2F7A74" borderRadius="8px" color="white" padding="8px 20px" text={t("button.add_copons")}   nav={"/copons/add"}  />
            </div>
            <div>
                {isLoading ? <TableSkeleton cols={coponsColumns}/> : (  
                    <Table columns={coponsColumns} rows={coponsData} openDeleteConfirmation={openDeleteConfirmation} edit="/copons/edit" />
                )}
            </div>
            <div className="flex justify-center items-center py-5">
                <Pagination currentPage={currentPage} totalPages={last_page} handleChangePage={handlePageChange} />
            </div>
            {deleteConfirmation.isOpen && <DeleteRecord loadingDelete={loadingDelete} handelDelete={handelDelete} closeDeleteConfirmation={closeDeleteConfirmation} />}
        </div>
    );
};